import { render } from "./MobileSetPhoto.vue?vue&type=template&id=10f5ee26&scoped=true"
import script from "./MobileSetPhoto.vue?vue&type=script&lang=js"
export * from "./MobileSetPhoto.vue?vue&type=script&lang=js"

import "./MobileSetPhoto.vue?vue&type=style&index=0&id=10f5ee26&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-10f5ee26"

export default script